import React from "react";

import { ImpressionProviderProps } from "./ImpressionProviderProps";

interface IProps extends ImpressionProviderProps {
  children: React.ReactNode;
}

export const BrandTileClickImpressionProvider: React.FC<IProps> = ({
  children,
}) => {
  // TODO(Fabio): Implement click tracking
  return <>{children}</>;
};
